import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("cc_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

/**
 * Remove empty-string / null / undefined values from an object before POSTing.
 * Backend Pydantic Optional[EmailStr] rejects empty string ("") — this helper
 * ensures optional form fields become truly absent when the user leaves them blank.
 */
export function pruneEmpty(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj || {})) {
    if (v === "" || v === null || v === undefined) continue;
    out[k] = v;
  }
  return out;
}

/**
 * Build a browser-usable image URL from either:
 *   - a legacy absolute URL (http/https) → returned unchanged
 *   - a relative backend path like "/api/files/abc" → absolute + ?auth=<token>
 *     so <img src> works without a custom header.
 */
export function authFileUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const token = localStorage.getItem("cc_token");
  const base = API_BASE.replace(/\/+$/, "");
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${base}${path}${token ? `?auth=${encodeURIComponent(token)}` : ""}`;
}
